module.exports = __webpack_public_path__ + "static/media/fig_27.70e704c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_27.jpg
// module id = 666
// module chunks = 0